// 회사별로 마지막 열 매핑을 기억한다(localStorage). 못 읽고 못 써도 가져오기는 그대로 돈다.

import { normLabel } from "./detect";
import { ColumnMap, IMPORT_FIELDS, ImportField } from "./types";

const KEY = "buildpy.import-columns.";

/** 머리글 글자 → 채울 곳("none" = 버림). */
export type MappingMemory = Record<string, ImportField | "none">;

const isField = (v: unknown): v is ImportField | "none" =>
  v === "none" || (typeof v === "string" && (IMPORT_FIELDS as string[]).includes(v));

export const loadMapping = (orgId: string): MappingMemory => {
  try {
    const raw = window.localStorage.getItem(KEY + orgId);
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return {};
    const out: MappingMemory = {};
    for (const [k, v] of Object.entries(parsed as Record<string, unknown>)) {
      if (isField(v)) out[k] = v;
    }
    return out;
  } catch {
    return {};
  }
};

// 열마다 기억 열쇠 — 같은 머리글이 여러 번이면 두 번째부터 「단가#2」 처럼 등장 순번을 붙인다.
const keysOf = (labels: string[]): string[] => {
  const count = new Map<string, number>();
  return labels.map((label) => {
    const k = normLabel(label);
    if (k === "") return "";
    const n = (count.get(k) ?? 0) + 1;
    count.set(k, n);
    return n === 1 ? k : `${k}#${n}`;
  });
};

export const saveMapping = (orgId: string, labels: string[], columns: ColumnMap): void => {
  try {
    const next = loadMapping(orgId);
    keysOf(labels).forEach((k, i) => {
      if (k !== "") next[k] = columns[i] ?? "none";
    });
    window.localStorage.setItem(KEY + orgId, JSON.stringify(next));
  } catch {
    // 저장 공간이 막혀도 가져오기는 끝났다 — 다음에 추정부터 다시 할 뿐이다.
  }
};

/** 기억한 매핑을 추정 위에 얹는다. 같은 곳을 두 열이 채우게 되면 뒤 열을 비운다(금액 대조 열 제외). */
export const applyMapping = (
  labels: string[],
  guessed: ColumnMap,
  memory: MappingMemory
): ColumnMap => {
  const keys = keysOf(labels);
  const merged = labels.map((_, i) => {
    const hit = Object.prototype.hasOwnProperty.call(memory, keys[i]) ? memory[keys[i]] : undefined;
    if (hit === undefined) return guessed[i] ?? null;
    return hit === "none" ? null : hit;
  });
  const seen = new Set<ImportField>();
  return merged.map((f) => {
    if (f === null || f === "amount_part") return f;
    if (seen.has(f)) return null;
    seen.add(f);
    return f;
  });
};
